import { useTranslation } from 'react-i18next';

import Passcode from './Passcode';

interface SignupScreen4Props {
  handleContinue: (dataObj: any) => void;
}

export function SignupScreen4({ handleContinue }: SignupScreen4Props) {
  const { t } = useTranslation();

  const handleContinueForm = (code: string) => {
    const dataObj = {
      progress: 'screen4',
      code,
    };
    handleContinue(dataObj);
  };

  return (
    <>
      <h1 data-testid="set-passcode-title">{t('R037')}</h1>
      <p>{t('R038')}</p>
      <Passcode handleContinue={handleContinueForm} />
    </>
  );
}
